import React, { useEffect, useState } from 'react';
import {
  PaginationContainer,
  PaginationButton,
  PaginationSpan,
} from './styles';
import {
  IconChevronLeft,
  IconChevronRight,
  Input,
} from 'takeat-design-system-ui-kit';
import { clampValue } from '~/utils/functions';

export const Pagination = ({
  totalPages,
  currentPage,
  onChangePage,
  ...props
}) => {
  const [inputCurrentPage, setInputCurrentPage] = useState(currentPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onChangePage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onChangePage(currentPage + 1);
    }
  };

  useEffect(() => {
    if (currentPage > totalPages) {
      onChangePage(totalPages);
    }
  }, [currentPage, totalPages]);

  useEffect(() => {
    setInputCurrentPage(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (inputCurrentPage !== '') {
      onChangePage(inputCurrentPage);
    }
  }, [inputCurrentPage]);

  return (
    <PaginationContainer {...props}>
      <PaginationButton
        disabled={currentPage === 1}
        onClick={handlePreviousPage}
      >
        <IconChevronLeft />
      </PaginationButton>

      <Input
        value={inputCurrentPage}
        style={{
          width: 32,
          height: 32,
          padding: 4,
          textAlign: 'center',
        }}
        onFocus={() => {
          setInputCurrentPage('');
        }}
        onBlur={() => {
          setInputCurrentPage(currentPage);
        }}
        onChange={(e) => {
          setInputCurrentPage(clampValue(e.target.value, 1, totalPages));
        }}
      />

      <PaginationSpan>/</PaginationSpan>

      <PaginationSpan style={{ minWidth: 16 }}>{totalPages}</PaginationSpan>

      <PaginationButton
        disabled={currentPage === totalPages}
        onClick={handleNextPage}
      >
        <IconChevronRight />
      </PaginationButton>
    </PaginationContainer>
  );
};
